"use client";

import {useHydrateAtoms} from "jotai/utils";
import type {ReactNode} from "react";
import type {StudentsResult} from "@repo/actions/filterRelationsToStudents";
import {parentStudentsAtom} from "./parentStudents";

export function HydrateParentStudents({
	students,
	children,
}: {
	students: StudentsResult;
	children: ReactNode;
}) {
	useHydrateAtoms([[parentStudentsAtom, students]]);
	return children;
}
